import React from 'react';
import CaseStudys from '../index';
import styles from './styles.module.scss';
import GenuineITSystemsbanner from '../../../assets/casestudy/GenuineITSystemsbanner.webp';
import genuiunimg from '../../../assets/casestudy/Genuine IT Systems.webp';
import Genuiun2ndimg from '../../../assets/casestudy/genuiun2ndimg.webp';
import Genuine3rimg from '../../../assets/casestudy/genuine3rimg.webp';
import KumarPhotography from '../../../assets/img/KumarPhotoGraphy.png';
import Wordpressicon from '../../../assets/img/wordpressicon.svg';
import hostec1stimg from '../../../assets/casestudy/hostec1stimg.webp';
import Gnanodaya1stimg from '../../../assets/casestudy/gnanodaya1stimg.webp';
const GenuineITSystems = () => {
  const caseStudiesB = [
 
   {
    image: Gnanodaya1stimg,
    title: 'Gnanodaya VLSI Technologies',
    category: 'Website Design',
    pagelink:'/genuineitsystems',
    link: 'https://gnanodayavlsi.com/',
  },
    {
    image: hostec1stimg,
    title: 'Hostec',
     pagelink:'/hostec',
    category: 'Website Design',
    link: 'https://www.hostec.in/',
  },
];
  const servicesB = [
  { label: 'UI & UX Design', link: 'https://metasoft.ae/services' },
  { label: 'Web Development', link: 'https://metasoft.ae/services' },
  { label: 'Performance Optimization', link: 'https://metasoft.ae/services'},
  { label: 'SEO', link: 'https://metasoftdm.com/marketing-solutions/seo/'},
];
  return (
    <CaseStudys
      title="Genuine IT Systems"
 caseStudies={caseStudiesB}
       
      subtitle="Crafting a Visual Platform for a Visual Brand"
      header='Designed website to highlight cutting-edge AV and tech solutions'
      websiteUrl='https://www.genitsgroup.com/'
      industry="Audio-Visual (AV) Solutions and Technology Integration"
    services={servicesB}
      description={
        <>
          <span>Genuine IT</span> Group is a leading provider of audio-visual, lighting, and digital signage solutions, with over 12 years of experience. They specialize in creating dynamic, tech-enabled environments for businesses and institutions, offering tailored AV integrations for seamless communication and enhanced experiences.
        </>
      }
      objective={{
        heading: 'Building a Simple Online Store to Boost Genuine IT’s Sales and Trust',
        content: (
          <>
            <p className={styles.projectText}>
            The objective of the Genits Group website was to establish a strong online presence that effectively showcases their expertise in digital transformation and IT services. The website aims to provide a clear, professional representation of their capabilities in data-driven marketing, omnichannel solutions, and IT strategy. The goal was to create a user-friendly platform that highlights their successful projects, fosters trust with potential clients, and provides easy access to key information and contact opportunities, ultimately supporting Genits Group’s growth and leadership in the digital services industry.
            </p>

            
          </>
        ),
      }}
      process={{
        heading: "Steps Taken to Create a Smooth Shopping Experience",
        content: (
          <>
            <p className={styles.projectText}>
           The process of designing the Genits Group website began with a thorough understanding of the client’s business goals and target audience. We conducted detailed research to understand their offerings in digital transformation, IT services, and marketing strategies. This research helped inform the website's design, focusing on a modern, professional aesthetic that aligns with the company’s brand.
            </p>

         

            <p className={styles.projectText}>
           The next step was to create wireframes and mockups, focusing on user experience (UX) and easy navigation. This ensured that the content was clearly presented, with intuitive navigation and a streamlined path for visitors to find information about their services and case studies.
Once the structure and design were finalized, we moved to the development phase, ensuring the website was fully responsive across all devices. The site was optimized for speed and performance, offering a seamless browsing experience. We also incorporated SEO best practices to improve visibility and ensure the site ranks well in search results.
            </p>
             <p className={styles.projectText}>
           Finally, we conducted user testing to refine the design and functionality before the site went live. The end result is a user-friendly, visually appealing website that effectively communicates Genits Group’s expertise and enhances their digital presence.
            </p>
          </>
        ),
      }}
      impact={{
        heading: 'Results from Building a Better Online Store',
        content: (
          <>
            
            <p className={styles.projectText}>
           The impact of the new Genits Group website has been significant in enhancing the company's online presence and business development efforts. By offering a modern, user-friendly interface, the website has made it easier for potential clients to understand Genits Group’s expertise in digital transformation, IT services, and data-driven marketing. The clean design and clear navigation have improved user engagement, resulting in increased time spent on the site and a higher rate of inquiries from prospective clients.
            </p>
            <p className={styles.projectText}>
          The website’s responsive design ensures a seamless experience across devices, further expanding its reach to a broader audience. Additionally, with the incorporation of SEO best practices, the site has seen improvements in search engine rankings, driving organic traffic. Overall, the website has positioned Genits Group as a trusted leader in their industry, helping to attract new business and strengthen client relationships.
            </p>
          </>
        ),
      }}
       conclusion={{
        heading: 'Wrapping Up the Project',
        content: (
          <>
            <p className={styles.projectText}>
         In conclusion, the Genits Group website has successfully achieved its goal of providing a modern, professional platform that showcases the company’s expertise in digital transformation and IT services. The intuitive design and user-friendly navigation have improved client engagement and facilitated easier access to important information. By enhancing the company’s online presence, the website has helped strengthen Genits Group’s position as a leader in the digital services industry, while also attracting new business opportunities and fostering stronger relationships with clients. This project not only reflects Genits Group’s innovative approach but also reinforces their commitment to delivering impactful digital solutions.
            </p>
           
          </>
        ),
      }}
      heroImage={GenuineITSystemsbanner} // Add the hero image
      projectImage={genuiunimg}
            projectImage2={Genuiun2ndimg}
              projectImage3={Genuine3rimg} // Add the project image
      technologies={[
        { name: 'Word Press', icon: Wordpressicon },
    
      ]} // Add the technologies used
      timescale="18 Weeks" // Add the timescale
      launchDate="February 2025" // Add the launch date
    />
  );
};

export default GenuineITSystems;